export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    title: '#',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 70,
    slots: { default: 'opt' },
  },
  {
    field: 'defaultImageUrl',
    width: 120,
    title: that.$l('INDEX.table_label_image') || '图片',
    align: 'center',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title:  that.$l('table_label_goods_name') || '产品名称',
    field: 'goodsName',
    minWidth: 240,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'skuInfo' },
  },
  {
    title:  that.$l('table_label_goods_color') || '颜色尺寸',
    field: 'goodsColor',
    minWidth: 140,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'goodsColor' },
  },
  {
    title: that.$l('table_label_goods_no') || '产品编号',
    field: 'amzSkuNo',
    width: 130,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'amzSkuNo' },
  },
  {
    title: that.$l('table_label_ftyInvQty') || '国内库存',
    field: 'ftyInvQty',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'ftyInvQty' },
  },
  {
    title: that.$l('table_label_operateName') || '运营',
    field: 'operateName',
    width: 140,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_amzMarketName') || '市场',
    field: 'marketName',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_avgSalesVolume7d') || '日销',
    field: 'avgSalesVolume7d',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_fbaInvQty') || 'FBA库存',
    field: 'fbaInvQty',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'fbaInvQty' },
  },
]
